export const UNEXPECTED_ERROR_MSG =
  'An unexpected error has occurred while creating the factor. If the problem persists, please call the Help Desk.';
export const OKTA_VERIFY_PUSH_TIMEOUT_MSG =
  'The steps to configure Okta Verify Push were not completed in a timely manner. Please reselect Okta Verify Push from the dropdown below to retry setup.';

export const DEVICE_TYPE_OPTIONS = [
  {
    value: 'sms',
    label: 'Text Message',
  },
  {
    value: 'email',
    label: 'Email',
  },
  {
    value: 'voice',
    label: 'Voice',
  },
  {
    value: 'google',
    label: 'Google Authenticator',
  },
  {
    value: 'okta',
    label: 'Okta Verify',
  },
  { value: 'push', label: 'Okta Verify Push' },
];
